<div class="action-grid">
    <slot />
    <slot name="bottom" />
</div>

<style>
    .action-grid {
        display: flex;
        justify-content: center;
        flex-direction: row;
        flex-wrap: wrap;
    }
</style>
